/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Diff_Body1Inputs */

const en_diff_body1 = /** @type {(inputs: Diff_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A text diff on JSON is noisy because it reacts to formatting, indentation, and key order, none of which are part of the data. This tool parses both sides first and then walks the two values together, so it reports differences in the structure rather than in the characters. Reformatting a file produces no output at all.`)
};

const ko_diff_body1 = /** @type {(inputs: Diff_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON에 텍스트 diff를 돌리면 서식, 들여쓰기, 키 순서에 반응하기 때문에 시끄럽습니다. 이들은 데이터의 일부가 아닙니다. 이 도구는 양쪽을 먼저 파싱한 뒤 두 값을 함께 순회하므로, 문자가 아니라 구조의 차이를 보고합니다. 파일을 다시 포매팅하는 것만으로는 출력이 전혀 나오지 않습니다.`)
};

const ja_diff_body1 = /** @type {(inputs: Diff_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON にテキスト差分をかけると、書式、インデント、キー順序に反応するため騒がしくなります。これらはデータの一部ではありません。このツールは両側を先にパースし、2 つの値を一緒にたどるので、文字ではなく構造の差分を報告します。ファイルを再整形しただけでは出力は何も出ません。`)
};

/**
* | output |
* | --- |
* | "A text diff on JSON is noisy because it reacts to formatting, indentation, and key order, none of which are part of the data. This tool parses both sides fir..." |
*
* @param {Diff_Body1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const diff_body1 = /** @type {((inputs?: Diff_Body1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Diff_Body1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_diff_body1(inputs)
	if (locale === "ko") return ko_diff_body1(inputs)
	return ja_diff_body1(inputs)
});